export const pattern16Data = [
  {
    id: 1,
    koreanChunks: [
      "팀은 책임이 있다",
      "검토하는 것에 ",
      "고객 피드백을,",
      "분석하는 것에 시장 트렌드를,",
      "식별하기 위해 기회들을,",
      "그리고 실행하기 위해 전략적 변화를",
      ,
    ],
    englishChunks: [
      "The team is responsible",
      "for reviewing",
      "client feedback,",
      "analyzing market trends,",
      "to identify opportunities,",
      "and to implement strategic changes",
    ],
    fullEnglish:
      "The team is responsible for reviewing client feedback, analyzing market trends, to identify opportunities, and to implement strategic changes.",
    additionalExplanation:
      "왼쪽에서 오른쪽으로 읽는 순서를 유지하면서 해석하면 병렬구조의 글도 어렵지 않습니다..",
  },

  {
    id: 2,
    koreanChunks: [
      "새로운 매니저는",
      "개선했을 뿐만 아니라",
      "팀 커뮤니케이션을",
      "증가시켰다 전반적인 생산성을",
    ],
    englishChunks: [
      "The new manager",
      "not only improved",
      "team communication",
      "but also increased",
      "overall productivity",
    ],
    fullEnglish:
      "The new manager not only improved team communication but also increased overall productivity.",
    additionalExplanation:
      "접속사 해석 방법을 그대로 도입하면서 왼쪽에서 오른쪽으로의 영어 어순대로 읽는 법을 유지합니다.",
  },

  {
    id: 3,
    koreanChunks: [
      "당신은 할 수 있다",
      "완료거나",
      "그 보고서를 금요일까지",
      "또는 요청하거나",
      "연장을 당신의 상사로부터",
    ],
    englishChunks: [
      "You can",
      "either complete",
      "the report by Friday",
      "or request",
      "an extension from your supervisor",
    ],
    fullEnglish:
      "You can either complete the report by Friday or request an extension from your supervisor.",
    additionalExplanation:
      "접속사별로 끊어 읽으면 쉽습니다. 완료하거나, 요청하거나",
  },
  {
    id: 4,
    koreanChunks: [
      "인턴은 도울 것이다",
      "준비하는 것을 문서들",
      "그... 보여주는 결과들을",
      "그리고 조직하는 것을 회의들을",
    ],
    englishChunks: [
      "The intern will assist",
      "with preparing documents",
      "presenting findings",
      "and organizing meetings",
    ],
    fullEnglish:
      "The intern will assist with preparing documents presenting findings and organizing meetings.",
    additionalExplanation:
      "마찬가지로 전치사별로 끊어 읽으면 됩니다. 중간에 presenting은 전치사 없이 존재하는 것으로 수식입니다. 수식은 그..를 붙여서 앞의 내용을 보충하는 식으로 해석합니다.",
  },
  {
    id: 5,
    koreanChunks: [
      "나는 첨부했다",
      "내 이력서를",
      "당신의 고려를 위해",
      "그리고 환영할 것이다 그 기회를 ",
      "논의하기 위해 ",
      "어떻게 내가 기여할 수 있는지",
      "계속되는 성공과 성장에",
      "LifeWhiz의",
    ],
    englishChunks: [
      "I have attached",
      "my resume",
      "for your consideration",
      "and would welcome the opportunity",
      "to discuss",
      "how I can contribute",
      "to the continued success and growth",
      "of LifeWhiz",
    ],
    fullEnglish:
      "I have attached my resume for your consideration and would welcome the opportunity to discuss how I can contribute to the continued success and growth of LifeWhiz.",
    additionalExplanation:
      "이 문장은 여러 구문이 연결된 복합 문장입니다. 'have attached'와 'would welcome'이 접속사 'and'로 연결되어 있으며, 'to discuss'는 'opportunity'를 수식하는 부정사구입니다.",
  },
  {
    id: 6,
    koreanChunks: [
      "나는 성공적으로 이끌었다",
      "팀을 15명의 전문가들",
      "여러 부서에 걸쳐",
      "그리고 책임이 있었다",
      "완료에 대한",
      "1천만 달러 프로젝트",
      "그... 향상시킨",
      "운영 효율성을",
      "30%로",
    ],
    englishChunks: [
      "I successfully led",
      "a team of 15 professionals",
      "across multiple departments",
      "and was responsible",
      "for the completion",
      "of a $10 million project",
      "that enhanced operational efficiency",
      "by 30%",
    ],
    fullEnglish:
      "I successfully led a team of 15 professionals across multiple departments and was responsible for the completion of a $10 million project that enhanced operational efficiency by 30%.",
    additionalExplanation: "",
  },

  {
    id: 7,
    koreanChunks: [
      "10년 이상 경험",
      "이끄는 교차 기능 팀들을",
      "그리고 제공하는 복잡한 프로젝트들을",
      "기한 내에",
      "그리고 예산 제약 내에서,",
      "나는 흥분된다",
      "기회에 대해",
      "기여할",
      "LifeWhiz의 미션에",
      "혁신을 추진하는",
    ],
    englishChunks: [
      "With over a decade of experience",
      "in leading cross-functional teams",
      "and delivering complex projects",
      "within deadline",
      "and budget constraints",
      "I am excited",
      "about the opportunity",
      "to contribute",
      "to LifeWhiz's mission",
      "of driving innovation",
    ],
    fullEnglish:
      "With over a decade of experience in leading cross-functional teams and delivering complex projects within deadline and budget constraints, I am excited about the opportunity to contribute to LifeWhiz's mission of driving innovation.",
    additionalExplanation:
      "복잡한 문장의 경우 더 전치사단위로 쪼개서 지금 어느 부분에 연결되서 이야기하는건지 잘 따라가도록 합니다. 영어 어순대로 읽으면 그대로 읽힐것입니다.",
  },

  {
    id: 8,
    koreanChunks: [
      "이 명망 있는 행사는",
      "목표로 한다",
      "모으는 것을",
      "저명한 손님들을 함께",
      "지원하기 위해 고귀한 목적을",
      "그리고 중대하게 영향을 미치기 위해 우리 커뮤니티에",
    ],
    englishChunks: [
      "This prestigious event",
      "aims",
      "to bring",
      "distinguished guests together",
      "to support a noble cause",
      "and significantly impact our community",
    ],
    fullEnglish:
      "This prestigious event aims to bring distinguished guests together to support a noble cause and significantly impact our community.",
    additionalExplanation: "",
  },
  {
    id: 9,
    koreanChunks: [
      "그녀는 보유하고 있다 필요한 자질들과 전문성을",
      "뛰어나기 위해 그녀의 역할에서",
      "그리고 만들기 위해 중요한 기여들을",
      "당신 팀의 성공에",
    ],
    englishChunks: [
      "She possesses the necessary qualities and expertise",
      "to excel in her role",
      "and make significant contributions",
      "to your team's success",
    ],
    fullEnglish:
      "She possesses the necessary qualities and expertise to excel in her role and make significant contributions to your team's success.",
    additionalExplanation: "to exel and make 으로 병렬된 구조입니다.",
  },
  {
    id: 10,
    koreanChunks: [
      "그녀의 분석적 강점을 넘어서,",
      "마리아는 가지고 있다 뛰어난 능력을",
      "협력하는",
      "다양한 팀들과,",
      "관리하는 프로젝트 마감일을,",
      "그리고 유지하는 긍정적인 태도를",
      "심지어 상당한 압박 하에서도",
    ],
    englishChunks: [
      "Beyond her analytical strengths,",
      "Maria has an exceptional ability",
      "to collaborate",
      "with diverse teams,",
      "manage project deadlines,",
      "and maintain a positive attitude",
      "even under significant pressure",
    ],
    fullEnglish:
      "Beyond her analytical strengths, Maria has an exceptional ability to collaborate with diverse teams, manage project deadlines, and maintain a positive attitude even under significant pressure.",
    additionalExplanation:
      "to collaborate, manage, and maintain으로 병렬 구조가 사용되었습니다.",
  },
  {
    id: 11,
    koreanChunks: [
      "그녀의 역할에서,",
      "그녀는 감독한다 복잡한 프로젝트 워크플로우를,",
      "조정한다 팀 노력을,",
      "그리고 보장한다",
      "그.. 모든 결과물들이 충족하도록 우리의 엄격한 품질 기준을",
    ],
    englishChunks: [
      "In her role,",
      "she oversees complex project workflows,",
      "coordinates team efforts,",
      "and ensures",
      "that all deliverables meet our rigorous quality standards",
    ],
    fullEnglish:
      "In her role, she oversees complex project workflows, coordinates team efforts, and ensures that all deliverables meet our rigorous quality standards.",
    additionalExplanation:
      "oversees, coordinates, ensures로 병렬 구조가 사용되었습니다.",
  },
  {
    id: 12,
    koreanChunks: [
      "그녀의 직업 윤리와 협력적인 성격은",
      "만든다 그녀를 자산으로",
      "우리 회사에",
      "그리고 가치 있는 팀원으로",
      "그... 기여가 상당히 영향을 미치는",
      "우리 조직의 성공에",
    ],
    englishChunks: [
      "Her work ethic and collaborative nature",
      "make her an asset",
      "to our company",
      "and a valued team member",
      "whose contributions significantly impact",
      "our organization's success",
    ],
    fullEnglish:
      "Her work ethic and collaborative nature make her an asset to our company and a valued team member whose contributions significantly impact our organization's success.",
    additionalExplanation:
      "make her an asset와 a valued team member가 병렬 구조로 사용되었습니다.",
  },
  {
    id: 13,
    koreanChunks: [
      "나는 감사하다",
      "기회에",
      "기여할 당신의 팀에",
      "그리고 흥분된다",
      "배우는것을",
      "존경받는 전문가들로부터",
      "ABC 기업에서",
    ],
    englishChunks: [
      "I am grateful",
      "for the opportunity",
      "to contribute to your team",
      "and excited",
      "to learn",
      "from the esteemed professionals",
      "at ABC Corporation",
    ],
    fullEnglish:
      "I am grateful for the opportunity to contribute to your team and excited to learn from the esteemed professionals at ABC Corporation.",
    additionalExplanation:
      "to contribute와 to learn이 병렬 구조로 사용되었습니다.",
  },
  {
    id: 14,
    koreanChunks: [
      "나는 특히 기대하고 있다",
      "일하는 것을",
      "소셜미디어 캠페인에",
      "그리고 얻는 것을 통찰력을",
      "디지털 마케팅 전략에 대한 ",
    ],
    englishChunks: [
      "I am particularly looking forward",
      "to working",
      "on social media campaigns",
      "and gaining insights",
      "into digital marketing strategies",
    ],
    fullEnglish:
      "I am particularly looking forward to working on social media campaigns and gaining insights into digital marketing strategies.",
    additionalExplanation:
      "working on과 gaining이 병렬 구조로 사용되었습니다. 계속 전치사별로 끊어 읽으면 됩니다.",
  },
  {
    id: 15,
    koreanChunks: [
      "나는 기쁠 것이다",
      "제공하는 것 추가적인 세부 사항을",
      "나의 진행 중인 연구에 대한",
      "그리고 논의하는 것이",
      "어떻게 우리의 각각의 팀들이 함께 일할 수 있는지",
    ],
    englishChunks: [
      "I would be happy",
      "to provide additional details",
      "on my ongoing research",
      "and discuss",
      "how our respective teams could work together",
    ],
    fullEnglish:
      "I would be happy to provide additional details on my ongoing research and discuss how our respective teams could work together.",
    additionalExplanation: "to provide와 discuss가 병렬 구조로 사용되었습니다.",
  },
  {
    id: 16,
    koreanChunks: [
      "만약 당신이 필요하다면 추가적 도움이",
      "또는 있다면 추가적 질문이",
      "주저하지 마세요",
      "연락하는것을 우리에게",
    ],
    englishChunks: [
      "Should you require further assistance",
      "or have any additional questions",
      "please do not hesitate",
      "to contact us",
    ],
    fullEnglish:
      "Should you require further assistance or have any additional questions, please do not hesitate to contact us.",
    additionalExplanation:
      "조건절이 문장 앞에 위치하는 도치 구문이 사용되었습니다. 'Should you require'는 'If you should require'의 도치 형태입니다.",
  },
  {
    id: 17,
    koreanChunks: [
      "우리는 희망합니다",
      "가지기를 기쁨을 맞이하는 당신을 다시",

      "가까운 미래에",
      "그래서 우리가 제공할 수 있도록 당신에게",
      "뛰어난 경험을",
      "그..당신이 받을 자격이 있는",
    ],
    englishChunks: [
      "We hope",
      "to have the pleasure of welcoming you back",
      "in the near future",
      "so we can provide you",
      "with the outstanding experience",
      "you deserve",
    ],
    fullEnglish:
      "We hope to have the pleasure of welcoming you back in the near future so we can provide you with the outstanding experience you deserve.",
    additionalExplanation:
      "이 문장은 'We hope to have the pleasure'로 시작하여 목적을 나타내는 'so we can provide'로 이어지는 구조입니다. 'you deserve'는 'the outstanding experience'를 수식하는 관계절입니다.",
  },
  {
    id: 18,
    koreanChunks: [
      "나는 믿습니다",
      "나의 관련 기술과 풍부한 경험이 할 수 있을 것입니다",
      "더욱 향상시키는 것을 귀사의 온라인 존재감을",
      "그리고 도달하는 것을 귀사의 목표 고객에게",
      "더 큰 규모로",
    ],
    englishChunks: [
      "I believe",
      "my relevant skills and extensive experience will be able to",
      "further enhance your company's presence online",
      "and reach your targeted audience",
      "on a larger scale",
    ],
    fullEnglish:
      "I believe my relevant skills and extensive experience will be able to further enhance your company's presence online and reach your targeted audience on a larger scale.",
    additionalExplanation:
      "이 문장은 'I believe'로 시작하여 주어인 'my relevant skills and extensive experience'가 'will be able to'라는 조동사 표현과 함께 사용되었습니다. 'enhance'와 'reach'가 병렬 구조로 사용되었습니다.",
  },
];
